import { generateRandomId } from '@livechat/data-utils'

import { Rule, RuleCondition } from 'types/rules'

export const ADD_NEW_RULE_QUERY_ID = 'new'

export const getPlainCondition = (extractor: RuleCondition['extractor'], ruleId = ''): RuleCondition => ({
	id: `local-${generateRandomId()}`,
	ruleId,
	extractor,
	matcher: 'equals',
	pattern: '',
})

export const getNewPlainRule = (organizationId: string): Rule => ({
	id: ADD_NEW_RULE_QUERY_ID,
	organizationId,
	templateId: organizationId,
	order: 0,
	name: 'New Rule',
	conditions: [getPlainCondition('url', ADD_NEW_RULE_QUERY_ID)],
})
